export type Bonus = {
  number: string;
  title: string;
  price: string;
  body: string;
  image: string;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'The 10-Minute Pre-Class Calm Protocol',
    price: '$17',
    body: 'Room Scan → Sequence Scan → Language Scan → Scope Scan → Calm Entry. A ten-minute ritual before every class, so you walk in with three neutral phrases already chosen and you already know which posture families might need options today. Includes the 5-point Class Readiness Score and a printable one-pager.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/5dede839-ea40-4093-b348-98ed38154629.jpg',
  },
  {
    number: '02',
    title: 'The Neutral Language Upgrade Kit',
    price: '$19',
    body: 'Fifty phrase swaps and a "Say This / Instead of This" table. Replace "listen to your body", "be careful" and "this is good for your back" with language that offers real options, keeps the choice with the student, and never claims certainty you cannot own. Includes opening-class scripts and whole-room option phrases.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/26a4a9e0-1de3-429f-ae51-bbc7376ab52c.jpg',
  },
  {
    number: '03',
    title: 'The 90-Second PDF Retrieval Setup',
    price: '$9',
    body: 'Three hundred pages are worthless if you cannot find page 214 with someone waiting. File naming, folder structure, a search-term map per volume, the Student Waiting Mode protocol, and three timed drills. Ten minutes of setup, then you find any condition in under 90 seconds on your phone.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/e9767705-5941-4c35-9a4e-044e33872d3c.jpg',
  },
  {
    number: '04',
    title: 'The Studio Interview Scenario Builder',
    price: '$19',
    body: "Studios ask injury scenarios in interviews — ZipRecruiter's own hiring guide tells them to. Twelve real scenarios with model answers, built on the Acknowledge → Clarify → Offer Options → Stay Clear formula, plus a template for writing your own and a pre-interview review card.",
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/7b6de9e0-c1b0-41d9-9ff5-511d17e67334.jpg',
  },
  {
    number: '05',
    title: 'The Post-Class Trust Note Vault',
    price: '$15',
    body: 'Twenty-five copy-paste follow-up messages for email, DM and text — plus a "when to send / when not to send" matrix. Close a sensitive conversation warmly without drifting into advice that is not yours to give.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/3be894e4-c8f4-42dc-b87f-b57ff450b376.jpg',
  },
];
